<template>
  <div class="container">
    <uhero2
      :title="heroData.title"
      :body="heroData.body"
      :mobile_class="heroData.mobile"
      class="container"
    >
      <div class="">
        <div class="workshop-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile">
              {{ heroData.title }}
            </h3>
            <p class="workshop_desc_mobile">
              {{ heroData.body }}
            </p>
          </div>
        </div>
      </div>
    </uhero2>
  </div>
</template>

<script>
export default {
  data() {
    return {
      heroData: {
        title: "Join workshops and learn from the experts",
        body:
          "Every month we organize multiple workshops on various fields all over Bangladesh, hosted by the best of the best.",
        mobile: "workshop-hero-mobile",
      },
    };
  },
};
</script>
<style scoped>
.workshop__text_mobile {
  font-family: "Open-Sans", sans-serif;
}
.workshop_desc_mobile {
  font-family: "Open-Sans", sans-serif;
}
</style>
